export default "__VITE_PUBLIC_ASSET__1b25e434__"